/**
 * @fileoverview Root layout: the shell every route renders inside.
 * @module App
 */

import { Outlet } from "react-router-dom"

import "@/styles/App.css"

/**
 * Application shell.
 *
 * @description
 * It owns the paper — the grain, the background, the full-height column — and
 * nothing else. The header belongs to the screen rather than to the shell: it
 * carries the mode, and the error screens have no mode to show.
 *
 * @returns The layout wrapping the active route.
 */
export default function App() {
	return (
		<div className="app">
			<div className="app__content">
				<Outlet />
			</div>
		</div>
	)
}
